export default __webpack_public_path__ + "static/Vectormd-887ab6e4e7052e8eebd5763df548e047.png";